import { SelectionBox } from '@tryhackme/thm-ui-components';
import { useCallback } from 'react';
import type { UserData } from 'src/common/interfaces/user';
import { usePostOccupationDetailsMutation } from 'src/common/slices/occupation-details.slice';
import { occupationOptions } from 'src/features/manage-account/account-details/sections/occupation-details/occupation-details.constants';
import { StyledContainer, StyledContentContainer, StyledSelectionBoxItem, StyledSubtitle, StyledTitle } from '../reprofiling-shared.styles';
interface ReprofilingOccupationProps {
  userData: UserData['user'];
  selectedOccupation?: string;
  onSelectedOccupationChange: (occupation: string) => void;
  ourSuggestion?: string;
}
export const ReprofilingOccupation = ({
  userData,
  selectedOccupation,
  onSelectedOccupationChange
}: ReprofilingOccupationProps) => {
  const [postOccupationDetails] = usePostOccupationDetailsMutation();
  const onPressOccupationCard = useCallback((occupation: string) => {
    const payload = {
      fullName: userData.fullName,
      occupation,
      institutionType: userData?.demographics?.institutionType,
      institutionName: userData?.demographics?.institutionName,
      phoneNumber: userData?.demographics?.phoneNumber,
      reprofiling: true
    };
    onSelectedOccupationChange(occupation);
    postOccupationDetails(payload);
  }, [onSelectedOccupationChange, userData, postOccupationDetails]);
  return <StyledContainer data-sentry-element="StyledContainer" data-sentry-component="ReprofilingOccupation" data-sentry-source-file="occupation.tsx">
      <div>
        <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="occupation.tsx">Staying Put, or Stepping Into Something New?</StyledTitle>
        <StyledSubtitle data-sentry-element="StyledSubtitle" data-sentry-source-file="occupation.tsx">Let’s make sure your profile reflects your journey.</StyledSubtitle>
      </div>
      <StyledContentContainer data-sentry-element="StyledContentContainer" data-sentry-source-file="occupation.tsx">
        <SelectionBox gap="2.4rem" hasContent data-sentry-element="SelectionBox" data-sentry-source-file="occupation.tsx">
          {occupationOptions.map(occupation => {
          const {
            icon,
            option,
            hasContent,
            isDarkVersion
          } = occupation;
          const {
            label,
            value
          } = option;
          return <StyledSelectionBoxItem key={label} option={option} icon={icon} hasContent={hasContent} checked={value === selectedOccupation} onChange={() => onPressOccupationCard(value)} isDarkVersion={isDarkVersion} iconPosition="left" iconSize="1.6rem" />;
        })}
        </SelectionBox>
      </StyledContentContainer>
    </StyledContainer>;
};